












import {ChartDataTemplate, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Custom(),
      widget: "AuditOverdueOutstandingActions",
      title: "Overdue outstanding actions",
      cType: "column2d",
      params: {
        auditCategory: {...WParamTpl.auditCategory(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        rotateLabels: "1",
        slantLabels: "1",
        showLabels: "1",
        showValues: "1",
        canvasTopPadding: "12",
        legendCaption: "Legend",
        usePlotGradientColor: "0",
        xAxisName: "Responsibility group",
        yAxisName: "No. of actions",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Category: " + (config.params.auditCategory.value.title || "<All>")
    }
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()
      let responsibilityGroupIds: any[] = []

      async function dataFetcher(params: any) {
        const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
        const toDate = getTodayYYYYMMDD()
        const categoryID = params.auditCategory.value.value || 0
        const data = await executeQuery('micad4-audit', 'overdueOutstandingActions',
          {locale: "en-GB", fromDate, toDate, categoryID},
          dataFilter) // todo pass all parameters
        responsibilityGroupIds = data.map(item => item.labelId)
        return {data}
      }

      function dataplotClickCallback(label: string, val: any, data: any) {
        //ToDo: drill down datasource needs to take parameters as well
        if (!val) {
          return
        }
        const responsibilityGroupId = responsibilityGroupIds[data.index]
        bus.$emit("chartPopup", {
          title: "Overdue outstanding actions: " + label + " (" + val + ")",
          component: () => import("@/components/widgets/audit/AuditOverdueOutstandingActionsDrillDown.vue"),
          componentArgs: {fromDate, toDate, responsibilityGroupId},
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })

  function dataFilter(data: { name: string, overdueActionCount: number, colour: string, responsibilityGroupID: number }[]): any[] {
    return data.map((v) => {
      return {label: v.name, value: v.overdueActionCount, color: v.colour, labelId: v.responsibilityGroupID}
    })
  }
